/*
----------------------------
Module - _global
----------------------------
*/

import $ from 'jquery';

(function(){
    'use strict';

    // Global variables
    var fmg = {
        'fn': {},
        'vars': {}
    };

    // Functions

    // Function to extract a parameter value from the URL
    fmg.fn.getQueryParameter = function(variable) {

        var query = window.location.search.substring(1);
        var vars = query.split("&");
        
        for (var i=0;i<vars.length;i++) {
            
            var pair = vars[i].split("=");
            
            if (pair[0] == variable) {
                return pair[1];
            }
        }

        return(false);

    };

    // Debounce function (https://davidwalsh.name/javascript-debounce-function)
    fmg.fn.debounce = function(func, wait, immediate) {

        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };

    }

    // Function to get a cookie value
    fmg.fn.getCookie = function(cname) {

        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';

    }

    // Function to set a value in a cookie
    fmg.fn.setCookie = function(cname, cvalue, exdays) {

        var expires;

        if (exdays) {
            var d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            expires = 'expires=' + d.toUTCString();
        } else {
            expires = "";
        }
        
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';

    }

    // Function that takes a date object and converts to yyyymmdd string
    fmg.fn.formatToISODate = function(date) {

        var month = (date.getMonth() + 1).toString();
        var day = (date.getDate()).toString();
        var year = date.getFullYear().toString();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join("");

    }

    // Function to delete cookie
    fmg.fn.deleteCookie = function(cname) {
        document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }

    // Sanitize string
    fmg.fn.sanitizeString = function(str) {
        var temp = document.createElement('div');
        temp.textContent = str;
        return temp.innerHTML;
    }

    fmg.fn.viewportCheck = fmg.fn.debounce(function () {

        // the body tag index value represents the screen sizes
        var elementIndex = parseInt($('body').css('z-index'));

        if (elementIndex != fmg.vars.screensize) {
            
            // viewport has changed
            fmg.vars.screensize = elementIndex;
            
            fmg.fn.viewportChanged();

        }

    }, 150)


    fmg.fn.viewportChanged = function() {
    
        fmg.header.refresh(); // src/modules/header/global.js
        fmg.mobileMenu.refresh(); // src/modules/mobile-menu.js
        fmg.mainNav.refresh(); // src/modules/main-nav.js
        fmg.eventsHeader.refresh(); // src/modules/events-header/global.js
        fmg.newsFiltersModal.refresh(); // src/modules/news-filters/global.js
        fmg.searchFiltersModal.refresh(); // src/modules/search-filters/global.js
    }

    // This function checkcs that if supplied jQuery obejct is within the specified parent selector
    // parent_selector argument is a string e.g. #foo or .foo
    fmg.fn.isElementWithinParent = function($element, parent_selector) {
        
        if($element.closest(parent_selector).length) {
            return true;
        } else {
            return false;
        }

    }

    fmg.fn.distinctArrayBy = function(arr, propName) {

        var filtered_array = arr.reduce(function (arr1, e1) {
            
            var matches = arr1.filter(function (e2) {
                return e1[propName] == e2[propName];
            })

            if (matches.length == 0) {
                arr1.push(e1)
            }
            
            return arr1;

        }, []);
    
        return filtered_array;
    }

    // Make fmg variable available to the console for debugging
    window.fmg = fmg;

    // Need "window load" rather than "document DOMContentLoaded" because need CSS to fully load first in order to get proper z-index
    // Otherwise end up with "auto" as the initial value
    window.addEventListener('load', (event) => {
        window.addEventListener('resize', fmg.fn.viewportCheck);
        fmg.fn.viewportCheck();
    });

}());
